import * as Yup from 'yup';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import LoadingButton from '@mui/lab/LoadingButton';
import { toast } from 'react-toastify';
import { Field, Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, { API_ROUTES } from '../../../utils/constant';

interface TeamsInfo {
  userTeamKey: string;
}

export default function AddTeams() {
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    userTeamKey: Yup.string()
      .required('Team name is required')
      .matches(
        /^[A-Z]{3} Team$/,
        'Team name must be in the format "AAA Team" where AAA are 3 uppercase letters only and then Team  (e.g., ARG Team, IND Team)'
      )
      .test(
        'valid-team-format',
        'Team name must be in the format "AAA Team" where AAA are 3 uppercase letters only and then Team  (e.g., ARG Team, IND Team)',
        (value) => {
          if (!value) return true; // Let required() handle empty values
          const parts = value.split(' ');
          return (
            parts.length === 2 &&
            parts[0].length === 3 &&
            /^[A-Z]{3}$/.test(parts[0]) &&
            parts[1] === 'Team'
          );
        }
      ),
  });

  const onClose = () => {
    navigate(PAGE_ROUTES.TEAMS);
  };

  return (
    <Box sx={{ margin: 2 }}>
      <Formik
        initialValues={{
          userTeamKey: '',
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          const info: TeamsInfo = {
            userTeamKey: values.userTeamKey,
          };

          try {
            await HttpService.post(API_ROUTES.createTeam, info);
            toast.success('Team created successfully', {
              position: 'bottom-right',
            });
            navigate(PAGE_ROUTES.TEAMS);
          } catch (error) {
            console.error(error);
          }
        }}
      >
        {({ errors, touched, isSubmitting, isValid }) => {
          return (
            <Form>
              <Card sx={{ p: 3 }}>
                <Box
                  rowGap={3}
                  columnGap={2}
                  display="grid"
                  gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  }}
                  sx={{ marginTop: '10px' }}
                >
                  <Field
                    name="userTeamKey"
                    as={TextField}
                    label="Team Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    helperText={
                      touched.userTeamKey && errors.userTeamKey
                        ? errors.userTeamKey
                        : null
                    }
                    error={touched.userTeamKey && !!errors.userTeamKey}
                  />
                </Box>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 2,
                    gap: 2,
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={isSubmitting || !isValid}
                  >
                    Create Team
                  </LoadingButton>
                </Stack>
              </Card>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}
